import React, { useState } from "react";
import { useSubmitResumeMutation } from "../../store/api/scholineApi.js";

const ApplyModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    occupation: "",
    question: "",
    detail: "",
    upload: null,
  });

  const [statusMessage, setStatusMessage] = useState(null); 
  const [submitResume, { isLoading }] = useSubmitResumeMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("firstname", formData.firstname);
    data.append("lastname", formData.lastname);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("occupation", formData.occupation);    
    data.append("question", formData.question === "yes");
    data.append("detail", formData.detail || "");
    if (formData.upload) data.append("upload", formData.upload);

    try {
      await submitResume(data).unwrap();
      setStatusMessage({
        type: "success",
        text: "Candidature soumise avec succès !",
      });
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        occupation: "",
        diplome: "",
        question: "",        
        upload: null,
      });

      
      setTimeout(() => {
        setStatusMessage(null);
        onClose();
      }, 2000);
    } catch (err) {
      console.error("Erreur de soumission :", err);
      setStatusMessage({
        type: "error",
        text: "Échec de l’envoi. Veuillez vérifier vos informations.",
      });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-xl p-6 w-full max-w-md relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-sm"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold text-center mb-1 text-[#6a56f6]">
          Devenez un agent commercial Scholine
        </h2>
        <p className="text-center text-gray-500 mb-6 text-xs">
          Rejoignez notre équipe et aidez-nous à offrir des solutions éducatives
          de qualité aux écoles à travers l’Algérie.
        </p>

        
        {statusMessage && (
          <div
            className={`text-center text-xs font-medium mb-4 p-2 rounded-lg ${
              statusMessage.type === "success"
                ? "bg-green-100 text-green-700 border border-green-300"
                : "bg-red-100 text-red-700 border border-red-300"
            }`}
          >
            {statusMessage.text}
          </div>
        )}

        <form className="space-y-4" onSubmit={handleSubmit}>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Nom
              </label>
              <input
                type="text"
                placeholder="Entrez votre nom"
                value={formData.firstname}
                onChange={(e) =>
                  setFormData({ ...formData, firstname: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Prénom
              </label>
              <input
                type="text"
                placeholder="Entrez votre prénom"
                value={formData.lastname}
                onChange={(e) =>
                  setFormData({ ...formData, lastname: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
              />
            </div>
          </div>

          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Adresse e-mail
              </label>
              <input
                type="email"
                placeholder="Entrez votre adresse e-mail"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Numéro de téléphone
              </label>
              <input
                type="tel"
                placeholder="Entrez votre numéro de téléphone"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Profession actuelle
            </label>
            <input
              type="text"
              placeholder="ex. Responsable commercial, Enseignant"
              value={formData.occupation}
              onChange={(e) =>
                setFormData({ ...formData, occupation: e.target.value })
              }
              className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
            />
          </div>
         
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Avez-vous déjà travaillé dans le domaine de l’éducation ?
            </label>
            <select
              value={formData.question}
              onChange={(e) =>
                setFormData({ ...formData, question: e.target.value })
              }
              className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-gray-600 text-xs"
            >
              <option value="">Sélectionnez une option</option>
              <option value="yes">Oui</option>
              <option value="no">Non</option>
            </select>
          </div>

          {formData.question === "yes" && (
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Décrivez votre expérience
              </label>
              <textarea
                rows="3"
                placeholder="Décrivez brièvement votre expérience..."
                value={formData.detail}
                onChange={(e) =>
                  setFormData({ ...formData, detail: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-[#6a56f6] focus:outline-none text-xs"
              ></textarea>
            </div>
          )}

          
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Télécharger votre CV
            </label>

            <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 text-center cursor-pointer hover:border-[#6a56f6] transition">
              <input
                type="file"
                id="cv-upload"
                className="hidden"
                onChange={(e) =>
                  setFormData({ ...formData, upload: e.target.files[0] })
                }
              />
              <label
                htmlFor="cv-upload"
                className="flex flex-col items-center text-gray-500 cursor-pointer text-xs"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-[#6a56f6] mb-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                <p>
                  Téléchargez ou glissez un fichier ici
                  <br />
                  <span className="text-gray-400 text-xs">
                    PNG, JPG, PDF jusqu’à 10 Mo
                  </span>
                </p>
              </label>

              {formData.upload && (
                <p className="mt-2 text-xs text-green-600">
                  Fichier sélectionné : {formData.upload.name}
                </p>
              )}
            </div>
          </div>

          
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#6a56f6] hover:bg-[#5a46e0] text-white py-2 rounded-lg font-semibold text-sm shadow-md transition"
          >
            {isLoading ? "Envoi..." : "Soumettre la candidature"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApplyModal;
